module.exports = __webpack_public_path__ + "static/ts-acc-app.a1ab691b.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/ts-acc-app.png
// module id = 104
// module chunks = 35783957827783 227738586966018